import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import ContentSave from 'material-ui/svg-icons/content/save';
import CircularProgress from 'material-ui/CircularProgress';

export class SaveButtonForTransfer extends Component {
    handleClick = e => {
        if (this.props.saving) {
            // prevent double submission
            e.preventDefault();
        } else {
            // always submit form explicitly regardless of button type
            const {handleSubmitWithRedirect, redirect} = this.props;
            if (e) {
                e.preventDefault();
            }
            handleSubmitWithRedirect(redirect)();
        }
    };

    render() {
        const {
            disabled,
            saving,
            raised = true,
            submitOnEnter,
            redirect,
        } = this.props;
        const type = submitOnEnter ? 'submit' : 'button';
        const ButtonComponent = raised ? RaisedButton : FlatButton;
        return (
            <ButtonComponent
                type={type}
                label="Create Transfer"
                disabled={disabled}
                icon={
                    saving && saving.redirect === redirect ? (
                        <CircularProgress size={25} thickness={2}/>
                    ) : (
                        <ContentSave/>
                    )
                }
                onClick={this.handleClick}
                primary={!saving}
                style={{
                    margin: '10px 24px',
                    position: 'relative',
                }}
            />
        );
    }
}

SaveButtonForTransfer.propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string,
    raised: PropTypes.bool,
    saving: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    submitOnEnter: PropTypes.bool,
    handleSubmitWithRedirect: PropTypes.func,
    redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

SaveButtonForTransfer.defaultProps = {
    disabled: true,
    handleSubmitWithRedirect: () => () => {
    },
};

const checkForm = (values) => {
    return (
        values.location_from !== null &&
        values.location_to !== null &&
        values.location_from !== values.location_to &&
        values.transfer_items.length > 0
    )
};

const mapStateToProps = (state) => {
    let form = state.form['record-form'];
    if (form && form.values) {
        return {
            disabled: !checkForm(form.values),
            saving: state.admin.saving,
        }
    }
    return {}
};

export default connect(mapStateToProps)(SaveButtonForTransfer);



// WEBPACK FOOTER //
// ./src/Fuse/buttons/SaveButtonForTransfer.js